(function($) {

// Hamburger Toggle

     $(document).ready(function() {
        $('.first-button').on('click', function() {

            $('.animated-icon1').toggleClass('open');
        });

    });


// on Scroll logo resize
    /*  Header onscroll background-color */
        $(window).on("scroll", function() {
            if ($(window).scrollTop() > 50) {
                $(".navbar-top").addClass("none-navbar");
                $(".fixed-top-header").addClass("fixed-top-header-zero");
            } else {
                $(".navbar-top").removeClass("none-navbar");
                $(".fixed-top-header").removeClass("fixed-top-header-zero");
            }
        });

    
})(jQuery);